import React from 'react'
import TextManipulator from './TextManipulator'

const POC = () => {
    return (
        <>
            <TextManipulator elementType="textarea" />
            <TextManipulator elementType="input" />
            <TextManipulator elementType="contenteditable" />
        </>

    )
}

export default POC